export const TicketStatus = {
  NotStarted: 6,
  Responded: 7,
  ResolutionInProgress: 8,
  TestingInProgress: 9,
  Resolved: 10,
  Differed: 11,
  Cancelled: 12,
};

export const TaskStatus = {
  NotStarted: 1,
  InProgress: 2,
  OnHold: 3,
  Completed: 4,
};

export const TicketType = {
  repeated: 1,
  new: 0,
};

//For Management report  5659d041-c4b1-41dc-b46f-b2c3fd5c2c3a
export const PowerBiAuthentication = {
  clientId: "cf021803-4d98-4bba-8c8e-7f3d1a51ed8b",
  clientSecret: "hCI8Q~kyK5RlXtSU13gi5SS1IjNn1a2wR1RCobqy",
  tenantId: "fdcd3b62-88bb-4c4c-bc7e-fdf7f96d8eab",
  reportId:  "5659d041-c4b1-41dc-b46f-b2c3fd5c2c3a",// "3f44ba42-1ce5-4a7c-8f57-99026e64da37",
  workspaceId: "6a8d6f17-91f0-4a7c-9ea0-d5ad17021111",
};

//For HR report
export const PowerBiAuthenticationHR = {
  clientId: "cf021803-4d98-4bba-8c8e-7f3d1a51ed8b",
  clientSecret: "hCI8Q~kyK5RlXtSU13gi5SS1IjNn1a2wR1RCobqy",
  tenantId: "fdcd3b62-88bb-4c4c-bc7e-fdf7f96d8eab",
  reportId: "e3c5c234-9f8b-4925-84de-a853f5b62961",//"6128808f-909b-460b-87fa-1db23d5fe788",
  workspaceId: "6a8d6f17-91f0-4a7c-9ea0-d5ad17021111",

}

export const notChargableResonsOptions = [
  {
    value: 1,
    label: "Reason 1",
  },
  {
    value: 2,
    label: "Reason 2",
  },
  {
    value: 3,
    label: "Reason 3",
  },
  {
    value: 4,
    label: "Reason 4",
  },
];

export const leaveTypeOptions = [
  {
    value: 1,
    label: "Full Day",
  },
  {
    value: 2,
    label: "First Half",
  },
  {
    value: 3,
    label: "Second Half",
  },
  // {
  //   value: 4,
  //   label: "ML",
  // },
];

export const priorityOptions = [
  {
    value: 1,
    label: "Showstopper",
  },
  {
    value: 2,
    label: "Critical",
  },
  {
    value: 3,
    label: "Medium",
  },
  {
    value: 4,
    label: "Low",
  },
];

export const enagagementTypeOptions = [
  {
    value: 1,
    label: "AMC",
  },
  {
    value: 2,
    label: "PRODUCT",
  },
  {
    value: 3,
    label: "PROJECT",
  },
  {
    value: 4,
    label: "T&M",
  },
  {
    value: 5,
    label: "INTERNAL",
  },
];

export const poStatusOptions = [
  {
    value: 1,
    label: "Recieved",
  },
  {
    value: 2,
    label: "Expired",
  },
  {
    value: 3,
    label: "Pending",
  },
  {
    value: 4,
    label: "Not Applicable",
  },
];

export const billingOptions = [
  {
    value: 1,
    label: "Monthly",
  },
  {
    value: 2,
    label: "Quarterly",
  },
  {
    value: 3,
    label: "Annual",
  },
  {
    value: 4,
    label: "Ticket Based",
  },
];

export const engagementStatusOptions = [
  {
    value: 1,
    label: "Not Started",
  },
  {
    value: 2,
    label: "In-Progress",
  },
  {
    value: 3,
    label: "Completed",
  },
];

export const streamOptions = [
  {
    value: 1,
    label: "AMC",
  },
  {
    value: 2,
    label: "Product",
  },
  {
    value: 3,
    label: "Project",
  },
  {
    value: 4,
    label: "T&M",
  },
  {
    value: 5,
    label: "Innovation",
  },
  {
    value: 6,
    label: "License/Infra Services",
  },
  {
    value: 7,
    label: "Internal",
  },
];

export const ActiveStatusOptions = [
  {
    value: true,
    label: "Active",
  },
  {
    value: false,
    label: "In Active",
  },
];
